// Prefer REACT_APP_API_URL when provided (local/prod).
// Fallback: prod -> hosted API, dev -> localhost.
export const nodeURL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BASE_API ||
  (process.env.NODE_ENV === "production"
    ? "https://yonetim.kaleplatform.com/api"
    : "http://localhost:5001");